/** Rutas del sandbox «Explorar» — sin módulos ni misiones guiadas en el chrome. */
export const EXPLORE_SANDBOX_PATHS = [
  "/scales/explorer",
  "/chords/explorer",
  "/modos",
  "/notas",
  "/melodies",
  "/songbook",
] as const;

export function isExploreSandboxPath(pathname: string): boolean {
  return EXPLORE_SANDBOX_PATHS.some(
    (p) => pathname === p || pathname.startsWith(`${p}/`)
  );
}
